
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"ci-primary",attrs:{"fill":"#ccc","d":"M253.924 127.592a64 64 0 1064 64 64.073 64.073 0 00-64-64zm0 96a32 32 0 1132-32 32.037 32.037 0 01-32 32z"}}),_c('path',{staticClass:"ci-primary",attrs:{"fill":"#ccc","d":"M376.906 68.515A173.922 173.922 0 00108.2 286.426l120.907 185.613a29.619 29.619 0 0049.635 0l120.911-185.613a173.921 173.921 0 00-22.747-217.911zm-4.065 200.444l-118.916 182.55-118.917-182.55c-36.4-55.879-28.593-130.659 18.563-177.817a141.92 141.92 0 01200.708 0c47.156 47.158 54.962 121.938 18.562 177.817z"}})])
          )
        }
      }
    